import { Tag } from 'antd'
import { PurchaseStatus } from 'helpers/PurchaseStatus'
import React from 'react'

interface PurchaseTagProps {
  status: PurchaseStatus
  style?: React.CSSProperties
}

const PurchaseTag = ({ status, style }: PurchaseTagProps) => {
  if (!status) return null
  return status === 'full' ? (
    <Tag color="success" style={{ width: 'fit-content', ...style }}>
      Satın Alındı
    </Tag>
  ) : (
    <Tag color="warning" style={{ width: 'fit-content', ...style }}>
      Kısmen Satın Alındı
    </Tag>
  )
}

export default PurchaseTag
